var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g, _path9, _path10, _path11, _path12, _path13, _path14, _g2, _path15, _path16, _path17, _g3, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _g4, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _g5, _path42, _path43, _path44, _g6, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgL101Theme(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 220,
    viewBox: "0 0 280 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_31)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.83 61.52C21.83 59.34 19.62 57.13 17.44 57.13C19.62 57.13 21.83 54.92 21.83 52.74C21.83 54.92 24.04 57.13 26.22 57.13C24.04 57.13 21.83 59.34 21.83 61.52Z",
    stroke: "#F8CB17",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.83 61.52C21.83 59.34 19.62 57.13 17.44 57.13C19.62 57.13 21.83 54.92 21.83 52.74C21.83 54.92 24.04 57.13 26.22 57.13C24.04 57.13 21.83 59.34 21.83 61.52Z",
    stroke: "#F8CB17",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M221.1 70.08C221.1 68.21 219.21 66.32 217.34 66.32C219.21 66.32 221.1 64.43 221.1 62.56C221.1 64.43 222.99 66.32 224.86 66.32C222.99 66.32 221.1 68.21 221.1 70.08Z",
    fill: "#85C340"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M221.1 70.08C221.1 68.21 219.21 66.32 217.34 66.32C219.21 66.32 221.1 64.43 221.1 62.56C221.1 64.43 222.99 66.32 224.86 66.32C222.99 66.32 221.1 68.21 221.1 70.08Z",
    fill: "#85C340"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.96 102.47V34C32.96 29.15 36.89 25.22 41.74 25.22H200.59C205.44 25.22 209.37 29.15 209.37 34V163.65C209.37 168.5 205.44 172.43 200.59 172.43H41.74C36.89 172.43 32.96 168.5 32.96 163.65V108.9",
    fill: "#E2E8F0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.96 102.47V34C32.96 29.15 36.89 25.22 41.74 25.22H200.59C205.44 25.22 209.37 29.15 209.37 34V163.65C209.37 168.5 205.44 172.43 200.59 172.43H41.74C36.89 172.43 32.96 168.5 32.96 163.65V108.9",
    stroke: "#0F172A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M174.9 25.22H201.47C205.84 25.22 209.37 28.76 209.37 33.12V49.44H32.96V33.12C32.96 28.75 36.5 25.22 40.86 25.22H174.89",
    fill: "#F17171"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_31",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 25,
    width: 178,
    height: 25
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M174.9 25.22H201.47C205.84 25.22 209.37 28.76 209.37 33.12V49.44H32.96V33.12C32.96 28.75 36.5 25.22 40.86 25.22H174.89",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_31)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.52 24.91V34.85C200.52 38.97 197.18 42.3 193.07 42.3H34.05V49.75H208.29V24.9H200.53L200.52 24.91Z",
    fill: "#EB4545"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M174.9 25.22H201.47C205.84 25.22 209.37 28.76 209.37 33.12V49.44H32.96V33.12C32.96 28.75 36.5 25.22 40.86 25.22H174.89",
    stroke: "#0F172A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M46.62 40.75C48.68 40.75 50.35 39.0801 50.35 37.02C50.35 34.96 48.68 33.29 46.62 33.29C44.56 33.29 42.89 34.96 42.89 37.02C42.89 39.0801 44.56 40.75 46.62 40.75Z",
    fill: "#020617"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M59.36 40.75C61.42 40.75 63.09 39.0801 63.09 37.02C63.09 34.96 61.42 33.29 59.36 33.29C57.3 33.29 55.63 34.96 55.63 37.02C55.63 39.0801 57.3 40.75 59.36 40.75Z",
    fill: "#020617"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M72.09 40.75C74.15 40.75 75.82 39.0801 75.82 37.02C75.82 34.96 74.15 33.29 72.09 33.29C70.03 33.29 68.36 34.96 68.36 37.02C68.36 39.0801 70.03 40.75 72.09 40.75Z",
    fill: "#020617"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M195.49 57.92H95.08C93.4231 57.92 92.08 59.2631 92.08 60.92V119.66C92.08 121.317 93.4231 122.66 95.08 122.66H195.49C197.147 122.66 198.49 121.317 198.49 119.66V60.92C198.49 59.2631 197.147 57.92 195.49 57.92Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_31",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 92,
    y: 57,
    width: 107,
    height: 66
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M195.49 57.92H95.08C93.4231 57.92 92.08 59.2631 92.08 60.92V119.66C92.08 121.317 93.4231 122.66 95.08 122.66H195.49C197.147 122.66 198.49 121.317 198.49 119.66V60.92C198.49 59.2631 197.147 57.92 195.49 57.92Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_31)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.91 33.72V52.4599L83.67 52.2599V94.2799H91.67V117.91C91.67 119.6 93.07 120.97 94.79 120.97C96.51 120.97 97.91 119.6 97.91 117.91V111.96C97.91 113.65 99.31 115.02 101.03 115.02C102.75 115.02 104.15 113.65 104.15 111.96V98.9799C104.15 97.2899 105.55 95.9199 107.27 95.9199C108.99 95.9199 110.39 97.2899 110.39 98.9799V111.96C110.39 113.65 111.79 115.02 113.51 115.02C115.02 115.02 116.27 113.97 116.57 112.58V106.4C116.57 106.19 116.59 105.98 116.64 105.77V105.13C116.64 105.29 116.66 105.45 116.68 105.61C117.03 104.3 118.25 103.33 119.7 103.33C121.26 103.33 122.55 104.45 122.78 105.92C122.85 105.67 122.89 105.41 122.89 105.14V111.85C122.89 114.45 125.04 116.56 127.7 116.56C130.36 116.56 132.51 114.45 132.51 111.85V105.14V104.36C132.51 102.67 133.91 101.3 135.63 101.3C137.35 101.3 138.75 102.67 138.75 104.36V105.14C138.75 106.83 140.15 108.2 141.87 108.2C143.47 108.2 144.78 107.01 144.96 105.49V70.69C145.1 72.26 146.42 73.5 148.06 73.5C149.79 73.5 151.23 72.13 151.23 70.44C151.23 70.7 151.29 81.62 151.29 81.62C151.29 83.31 152.69 84.68 154.41 84.68C155.92 84.68 157.17 83.6299 157.47 82.2399C157.47 82.2399 157.55 75.1199 157.58 75.2699C157.93 73.9599 159.15 72.9899 160.6 72.9899C162.16 72.9899 163.45 74.11 163.68 75.58C163.75 75.33 163.79 81.5 163.79 81.5C163.79 84.1 165.94 86.2099 168.6 86.2099C171.26 86.2099 173.41 84.1 173.41 81.5V74.79V74.01C173.41 72.32 174.81 70.9499 176.53 70.9499C178.25 70.9499 179.65 72.32 179.65 74.01V74.79C179.65 76.48 181.05 77.8499 182.77 77.8499C184.49 77.8499 185.89 76.48 185.89 74.79C185.89 76.48 187.29 77.8499 189.01 77.8499C190.73 77.8499 192.13 76.48 192.13 74.79C192.13 76.48 193.53 77.8499 195.25 77.8499C196.97 77.8499 198.37 76.48 198.37 74.79V61.8499H203.69V33.7H144.89L144.91 33.72Z",
    fill: "#FBDF47",
    stroke: "#020617",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M195.49 57.92H95.08C93.4231 57.92 92.08 59.2631 92.08 60.92V119.66C92.08 121.317 93.4231 122.66 95.08 122.66H195.49C197.147 122.66 198.49 121.317 198.49 119.66V60.92C198.49 59.2631 197.147 57.92 195.49 57.92Z",
    stroke: "#020617",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M107.67 162.78C116.28 162.78 123.26 155.8 123.26 147.19C123.26 138.58 116.28 131.6 107.67 131.6C99.0599 131.6 92.08 138.58 92.08 147.19C92.08 155.8 99.0599 162.78 107.67 162.78Z",
    fill: "#80D1E6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1_31",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 92,
    y: 131,
    width: 32,
    height: 32
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M107.67 162.78C116.28 162.78 123.26 155.8 123.26 147.19C123.26 138.58 116.28 131.6 107.67 131.6C99.0599 131.6 92.08 138.58 92.08 147.19C92.08 155.8 99.0599 162.78 107.67 162.78Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1_31)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.67 148.4C110.31 148.4 112.45 146.26 112.45 143.62C112.45 140.98 110.31 138.84 107.67 138.84C105.03 138.84 102.89 140.98 102.89 143.62C102.89 146.26 105.03 148.4 107.67 148.4Z",
    fill: "#FCD5A9",
    stroke: "#020617",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.67 171.34C113.265 171.34 117.8 166.384 117.8 160.27C117.8 154.156 113.265 149.2 107.67 149.2C102.075 149.2 97.54 154.156 97.54 160.27C97.54 166.384 102.075 171.34 107.67 171.34Z",
    fill: "#F17171",
    stroke: "#020617",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M107.67 162.78C116.28 162.78 123.26 155.8 123.26 147.19C123.26 138.58 116.28 131.6 107.67 131.6C99.0599 131.6 92.08 138.58 92.08 147.19C92.08 155.8 99.0599 162.78 107.67 162.78Z",
    stroke: "#020617",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M130.76 139.98H184.91",
    stroke: "#0F172A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M130.76 132.17H187.29",
    stroke: "#0F172A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M147.96 148.33H133.91C132.253 148.33 130.91 149.673 130.91 151.33V157.92C130.91 159.577 132.253 160.92 133.91 160.92H147.96C149.617 160.92 150.96 159.577 150.96 157.92V151.33C150.96 149.673 149.617 148.33 147.96 148.33Z",
    fill: "#C9D0E9",
    stroke: "#020617",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M173.08 148.33H159.03C157.373 148.33 156.03 149.673 156.03 151.33V157.92C156.03 159.577 157.373 160.92 159.03 160.92H173.08C174.737 160.92 176.08 159.577 176.08 157.92V151.33C176.08 149.673 174.737 148.33 173.08 148.33Z",
    fill: "#C9D0E9",
    stroke: "#020617",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M239.62 79.83H146.16C143.399 79.83 141.16 82.0685 141.16 84.83V110.5C141.16 113.261 143.399 115.5 146.16 115.5H239.62C242.381 115.5 244.62 113.261 244.62 110.5V84.83C244.62 82.0685 242.381 79.83 239.62 79.83Z",
    fill: "#FBDF47"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_1_31",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 141,
    y: 79,
    width: 104,
    height: 37
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M239.62 79.83H146.16C143.399 79.83 141.16 82.0685 141.16 84.83V110.5C141.16 113.261 143.399 115.5 146.16 115.5H239.62C242.381 115.5 244.62 113.261 244.62 110.5V84.83C244.62 82.0685 242.381 79.83 239.62 79.83Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_1_31)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M238.95 63.5199V107.52C238.95 108.68 238.01 109.62 236.85 109.62H40.44V123.76L253.09 123.13V63.5099H238.95V63.5199Z",
    fill: "#FBDF47"
  })))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M239.62 79.83H146.16C143.399 79.83 141.16 82.0685 141.16 84.83V110.5C141.16 113.261 143.399 115.5 146.16 115.5H239.62C242.381 115.5 244.62 113.261 244.62 110.5V84.83C244.62 82.0685 242.381 79.83 239.62 79.83Z",
    stroke: "#020617",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M192.67 154.58V146.67C192.67 140.37 197.03 134.91 203.18 133.52L252.99 122.27C255.53 121.7 257.34 119.43 257.34 116.83V102.41C257.34 99.33 254.84 96.83 251.76 96.83H245",
    stroke: "#020617",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M203.81 152.52C204.04 151.99 203.66 151.4 203.08 151.4H182.29C181.69 151.4 181.31 152.04 181.59 152.56L185.51 160L184.01 200.21C183.82 205.21 187.83 209.37 192.84 209.37C197.85 209.37 201.85 205.21 201.67 200.21L200.46 160L203.81 152.51V152.52Z",
    fill: "#21B580"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_1_31",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 181,
    y: 151,
    width: 23,
    height: 59
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M203.81 152.52C204.04 151.99 203.66 151.4 203.08 151.4H182.29C181.69 151.4 181.31 152.04 181.59 152.56L185.51 160L184.01 200.21C183.82 205.21 187.83 209.37 192.84 209.37C197.85 209.37 201.85 205.21 201.67 200.21L200.46 160L203.81 152.51V152.52Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_1_31)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.26 158.6L205.1 149.59H175.77L181.47 158.6L179.58 200.7C179.35 205.94 184.38 210.29 190.68 210.29C196.98 210.29 202.01 205.94 201.78 200.7L200.26 158.6Z",
    stroke: "#009569",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M203.81 152.52C204.04 151.99 203.66 151.4 203.08 151.4H182.29C181.69 151.4 181.31 152.04 181.59 152.56L185.51 160L184.01 200.21C183.82 205.21 187.83 209.37 192.84 209.37C197.85 209.37 201.85 205.21 201.67 200.21L200.46 160.207L203.81 152.52Z",
    stroke: "#020617",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M184.44 194.5H201.41",
    stroke: "#020617",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M184.44 159.34H201.41",
    stroke: "#020617",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M151.84 83.7399H239.87",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M146.04 83.7399H149.04",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M192.69 204.32C194.076 204.32 195.2 203.196 195.2 201.81C195.2 200.424 194.076 199.3 192.69 199.3C191.304 199.3 190.18 200.424 190.18 201.81C190.18 203.196 191.304 204.32 192.69 204.32Z",
    fill: "#231F20"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M81.13 58.6H46.73C45.0731 58.6 43.73 59.9431 43.73 61.6V94.09C43.73 95.7468 45.0731 97.09 46.73 97.09H81.13C82.7868 97.09 84.13 95.7468 84.13 94.09V61.6C84.13 59.9431 82.7868 58.6 81.13 58.6Z",
    fill: "white",
    stroke: "#020617",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M63.94 80.91C68.6068 80.91 72.39 77.1268 72.39 72.46C72.39 67.7932 68.6068 64.01 63.94 64.01C59.2732 64.01 55.49 67.7932 55.49 72.46C55.49 77.1268 59.2732 80.91 63.94 80.91Z",
    fill: "#46C4E1"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M57.64 91.66C62.3068 91.66 66.09 87.8768 66.09 83.21C66.09 78.5432 62.3068 74.76 57.64 74.76C52.9732 74.76 49.19 78.5432 49.19 83.21C49.19 87.8768 52.9732 91.66 57.64 91.66Z",
    fill: "#EB008B"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M70.23 91.66C74.8968 91.66 78.68 87.8768 78.68 83.21C78.68 78.5432 74.8968 74.76 70.23 74.76C65.5632 74.76 61.78 78.5432 61.78 83.21C61.78 87.8768 65.5632 91.66 70.23 91.66Z",
    fill: "#FBDF47"
  }))), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M17.01 94.92L17.37 198.94C17.38 201.85 19.75 204.2 22.66 204.19L70.33 204.02C73.24 204.01 75.59 201.64 75.58 198.73L75.22 94.71L17.01 94.91V94.92Z",
    fill: "#E2E8F0",
    stroke: "#0F172A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_1_31",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 94,
    width: 59,
    height: 111
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M17.01 94.92L17.37 198.94C17.38 201.85 19.75 204.2 22.66 204.19L70.33 204.02C73.24 204.01 75.59 201.64 75.58 198.73L75.22 94.71L17.01 94.91V94.92Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_1_31)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.14 94.04L16.5 198.06C16.51 200.97 18.88 203.32 21.79 203.31L69.46 203.14C72.37 203.13 74.72 200.76 74.71 197.85L74.35 93.83L16.14 94.03V94.04Z",
    stroke: "#CBD5E1",
    strokeWidth: 7,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M17.01 94.92L17.37 198.94C17.38 201.85 19.75 204.2 22.66 204.19L70.33 204.02C73.24 204.01 75.59 201.64 75.58 198.73L75.22 94.71L17.01 94.91V94.92Z",
    fill: "#E2E8F0",
    stroke: "#0F172A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9746 85.2491L69.1843 85.0878C72.4943 85.0763 75.1937 87.7569 75.2052 91.0669L75.2304 98.2668L17.0207 98.47L16.9956 91.27C16.984 87.9601 19.6646 85.2607 22.9746 85.2491Z",
    fill: "#F17171"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_1_31",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 85,
    width: 60,
    height: 14
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9746 85.2491L69.1843 85.0878C72.4943 85.0763 75.1937 87.7569 75.2052 91.0669L75.2304 98.2668L17.0207 98.47L16.9956 91.27C16.984 87.9601 19.6646 85.2607 22.9746 85.2491Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_1_31)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.36 94.56L74.32 83.55H71.44L71.47 93.07C71.47 93.9 70.78 94.58 69.93 94.58L2.88998 94.81V97.62L75.15 97.37V94.56H74.36Z",
    fill: "#EB4545"
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9746 85.2491L69.1843 85.0878C72.4943 85.0763 75.1937 87.7569 75.2052 91.0669L75.2304 98.2668L17.0207 98.47L16.9956 91.27C16.984 87.9601 19.6646 85.2607 22.9746 85.2491Z",
    stroke: "#0F172A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M39.635 105.341L27.3651 105.384C25.7082 105.389 24.3698 106.737 24.3756 108.394L24.4184 120.664C24.4242 122.321 25.772 123.659 27.4288 123.654L39.6988 123.611C41.3556 123.605 42.6941 122.257 42.6883 120.6L42.6454 108.33C42.6397 106.674 41.2918 105.335 39.635 105.341Z",
    fill: "#FBDF47",
    stroke: "#020617",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.52,
    d: "M28.5 109.22H38.32C38.76 109.22 39.12 109.58 39.12 110.02V119.84",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9545 105.252L52.6846 105.295C51.0277 105.301 49.6893 106.649 49.6951 108.306L49.7379 120.576C49.7437 122.233 51.0915 123.571 52.7484 123.565L65.0183 123.522C66.6751 123.517 68.0136 122.169 68.0078 120.512L67.965 108.242C67.9592 106.585 66.6114 105.247 64.9545 105.252Z",
    fill: "#F6903F",
    stroke: "#020617",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7069 128.8L27.437 128.843C25.7801 128.849 24.4417 130.197 24.4475 131.854L24.4903 144.124C24.4961 145.781 25.8439 147.119 27.5007 147.113L39.7707 147.07C41.4275 147.065 42.766 145.717 42.7602 144.06L42.7173 131.79C42.7116 130.133 41.3637 128.795 39.7069 128.8Z",
    fill: "#85C340",
    stroke: "#020617",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0264 128.712L52.7565 128.755C51.0996 128.761 49.7612 130.109 49.767 131.765L49.8098 144.035C49.8156 145.692 51.1634 147.031 52.8203 147.025L65.0902 146.982C66.747 146.976 68.0855 145.628 68.0797 143.972L68.0369 131.702C68.0311 130.045 66.6832 128.706 65.0264 128.712Z",
    fill: "#16A34A",
    stroke: "#020617",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7888 152.27L27.5189 152.313C25.862 152.319 24.5236 153.666 24.5294 155.323L24.5722 167.593C24.578 169.25 25.9258 170.589 27.5826 170.583L39.8526 170.54C41.5094 170.534 42.8479 169.186 42.8421 167.529L42.7993 155.26C42.7935 153.603 41.4456 152.264 39.7888 152.27Z",
    fill: "#2DA2DB",
    stroke: "#020617",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1083 152.182L52.8384 152.224C51.1816 152.23 49.8431 153.578 49.8489 155.235L49.8917 167.505C49.8975 169.162 51.2454 170.5 52.9022 170.494L65.1721 170.452C66.829 170.446 68.1674 169.098 68.1616 167.441L68.1188 155.171C68.113 153.514 66.7652 152.176 65.1083 152.182Z",
    fill: "#507ABC",
    stroke: "#020617",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8807 175.73L27.6108 175.772C25.9539 175.778 24.6155 177.126 24.6213 178.783L24.6641 191.053C24.6699 192.71 26.0177 194.048 27.6745 194.042L39.9445 193.999C41.6013 193.994 42.9398 192.646 42.934 190.989L42.8911 178.719C42.8854 177.062 41.5375 175.724 39.8807 175.73Z",
    fill: "#5559A6",
    stroke: "#020617",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1902 175.641L52.9203 175.684C51.2635 175.69 49.925 177.038 49.9308 178.695L49.9736 190.964C49.9794 192.621 51.3272 193.96 52.9841 193.954L65.254 193.911C66.9108 193.905 68.2493 192.557 68.2435 190.901L68.2007 178.631C68.1949 176.974 66.8471 175.635 65.1902 175.641Z",
    fill: "#7B53A1",
    stroke: "#020617",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M65.68 90.91H69.23",
    stroke: "#0F172A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.28
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 132.45H38.32C38.76 132.45 39.12 132.81 39.12 133.25V143.07",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 155.67H38.32C38.76 155.67 39.12 156.03 39.12 156.47V166.29",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 179.49H38.32C38.76 179.49 39.12 179.85 39.12 180.29V190.11",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M53.68 109.22H63.5C63.94 109.22 64.3 109.58 64.3 110.02V119.84",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M53.68 132.45H63.5C63.94 132.45 64.3 132.81 64.3 133.25V143.07",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M53.68 155.67H63.5C63.94 155.67 64.3 156.03 64.3 156.47V166.29",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M53.68 179.49H63.5C63.94 179.49 64.3 179.85 64.3 180.29V190.11",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M28.12 27.15H18.21",
    stroke: "#020617",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M31.65 22.96L23.45 14.77",
    stroke: "#020617",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M35.74 20.06V10.61",
    stroke: "#020617",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M216.34 20.87H222.71",
    stroke: "#F17171",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M219.53 17.72V24.08",
    stroke: "#F17171",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M218.92 144.75H224.72",
    stroke: "#80D1E6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M221.82 141.88V147.68",
    stroke: "#80D1E6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M229.13 47C230.864 47 232.27 45.5941 232.27 43.86C232.27 42.1258 230.864 40.72 229.13 40.72C227.396 40.72 225.99 42.1258 225.99 43.86C225.99 45.5941 227.396 47 229.13 47Z",
    stroke: "#80D1E6",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 77.53C24.6929 77.53 25.66 76.5629 25.66 75.37C25.66 74.177 24.6929 73.21 23.5 73.21C22.3071 73.21 21.34 74.177 21.34 75.37C21.34 76.5629 22.3071 77.53 23.5 77.53Z",
    fill: "#F29E1E"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M263 101.49V117.28",
    stroke: "#020617",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_31"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 280,
    height: 220,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgL101Theme);
export default __webpack_public_path__ + "static/media/L1_01_Theme.6a32994cf46380e312a8cacdcb1c6239.svg";
export { ForwardRef as ReactComponent };